import stickybits from 'stickybits';

export default {
  
  
  init() {
    
    // JavaScript to be fired on all pages
    
    $('.gform_button').addClass('button hvr-float');

    $('#menu-primary-navigation .menu-item-has-children').addClass('dropdown');
    $('#menu-primary-navigation .sub-menu').addClass('dropdown-list');

    $('#menu-footer-navigation .menu-item-has-children').addClass('dropup');
    $('#menu-footer-navigation .sub-menu').addClass('dropup-list');

    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      // $('.nav-primary').fadeToggle(200);
      // $('.nav-primary').toggleClass('show');
    });

    $('<button type="button" class="btn dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>').appendTo('.menu-item-has-children > a');

    $('.dropdown-toggle').click(function () {
      $(this).toggleClass('dropdown');
      $('.sub-menu').toggleClass('show', 10000, 'easeOutSine');
    });

    $('.sticky a').click(function () {
      $('.sticky a').removeClass('active');
      $(this).toggleClass('active');
    });

    stickybits('.sticky', {
      // the scroll duration for when .js-is-sticky--change is added
      customStickyChangeNumber: null,

      // without inline styles except for position: sticky or position: fixed
      noStyles: false,

      // offset in pixels
      stickyBitStickyOffset: 0,

      // custom Scroll Element
      scrollEl: window,

      // default CSS classes
      // parentClass: 'js-stickybit-parent',
      stickyClass: 'js-is-sticky',
      stuckClass: 'js-is-stuck',
      stickyChangeClass: 'js-is-sticky--change',

      // use position: sticky or position: fixed
      useFixed: false,

      // or bottom
      verticalPosition: 'top',

      // add and remove sticky CSS Classes
      // .js-is-sticky and .js-is-stuck
      useStickyClasses: true,

      // to not use offsetTop
      useGetBoundingClientRect: false,
        
    });
  },

  
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js